'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPersonAdd = function IoPersonAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31 25.6h-3.3v-4h-3.9v-3.2h3.9v-4h3.3v4h4v3.2h-4v4z m-1 9.4h-30s0-2 0.2-3.1c0.1-0.9 1.3-2 6.3-3.9 4.9-1.7 4.7-0.9 4.7-4.2 0-2.2-1.1-0.9-1.8-5-0.3-1.7-0.5-0.6-1.1-3.2-0.3-1.3 0.2-1.5 0.1-2.1s-0.1-1.2-0.3-2.6c-0.1-1.6 1.4-5.9 6.9-5.9s7 4.3 6.9 5.9c-0.2 1.4-0.3 2-0.3 2.6s0.4 0.8 0.1 2.1c-0.6 2.6-0.8 1.5-1.1 3.1-0.7 4.2-1.8 2.9-1.8 5 0 3.4-0.2 2.5 4.7 4.3 5 1.9 6.2 3 6.3 3.9 0.2 1.1 0.2 3.1 0.2 3.1z' })
        )
    );
};

exports.default = IoPersonAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/person-add.js
// module id = 2374
// module chunks = 0